export const generateInitialsForParticipant = ({
  firstName,
  lastName,
}: Participant) => `${firstName?.[0] || ''}${lastName?.[0] || ''}`;
